'use strict';

/**
 * 画面右下に追従するページ先頭へ戻るボタン
 *    - ファーストビューでは非表示
 *    - 画面下部に追従コンポーネントがある場合はその上に表示
 *    - 下まで来たらフッターの上に固定
 */
const $win = $(window);
const $footer = $('#footercontent');
const $btt = $('.back-to-top');
const cls = 'is-btm';
const $follow = $('.prices-add-to-cart-actions, .checkout-continue, .next-step-button');
const bttBtm = parseInt($btt.css('bottom'));
let followFlg = false;
let footerTop;
let btmPos;
let scrollBtm;

module.exports = function () {
    if (!$btt.length) {
        return false;
    }
    $win.on('load resize', function() {
        $btt.hide();
        followFlg = $follow.css('position') === 'fixed' ? true : false;
        footerTop = $footer.offset().top;
    });

    // ResizeObserberでサイズ監視(resizeイベントが効かないケースのため)
    const body = document.body; // body要素
    const observer = new ResizeObserver(function () {

        $win.trigger('resize');
    });
    observer.observe(body);

    $win.on('scroll', function() {
        if ($(this).scrollTop() > $win.height()) {
            $btt.fadeIn();

            // 画面下部に追従エリアがある場合
            btmPos = followFlg === true ? bttBtm + $follow.innerHeight() : bttBtm;
            $btt.css('bottom', btmPos);

            // 下まで来たらフッター上に固定
            if ($footer.length > 0){
                if (followFlg === true) {
                    scrollBtm = $win.scrollTop() + $win.height() - $follow.innerHeight();
                } else {
                    scrollBtm = $win.scrollTop() + $win.height();
                }

                if (scrollBtm >= footerTop) {
                    $btt.addClass(cls).css('top', footerTop);
                } else {
                    $btt.removeClass(cls).css('top', 'auto');
                }
            }
        }
        else {
            $btt.fadeOut(100);
        }
    });
};
